import type { ChatProject, DialogItem } from "@/lib/copilot-chat"

/** Сколько папок проектов видно, пока список не раскрыт полностью */
export const PROJECTS_COLLAPSED_LIMIT = 5

export interface ProjectGroup {
  project: ChatProject
  dialogs: DialogItem[]
  /** Последняя активность: новее из изменения папки и её чатов */
  activeAt: number
}

const time = (iso: string | undefined) => {
  const t = iso ? Date.parse(iso) : NaN
  return Number.isFinite(t) ? t : 0
}

/**
 * Чаты по папкам: папки — по последней активности (свежие сверху), чаты внутри — как пришли
 * (сервер сортирует по изменению). Чаты без папки или с удалённой папкой — в «Недавних».
 */
export function groupDialogsByProject(dialogs: DialogItem[], projects: ChatProject[]): { groups: ProjectGroup[]; recent: DialogItem[] } {
  const byId = new Map<string, ProjectGroup>(
    projects.map((p) => [p.id, { project: p, dialogs: [], activeAt: Math.max(time(p.updatedAt), time(p.createdAt)) }])
  )
  const recent: DialogItem[] = []
  for (const d of dialogs) {
    const group = d.projectId ? byId.get(d.projectId) : undefined
    if (!group) {
      recent.push(d)
      continue
    }
    group.dialogs.push(d)
    group.activeAt = Math.max(group.activeAt, time(d.updatedAt))
  }
  const groups = [...byId.values()].sort((a, b) => b.activeAt - a.activeAt)
  return { groups, recent }
}

/**
 * Видимые папки: все, если список раскрыт; иначе первые limit и папка открытого чата,
 * даже если она ниже — чтобы открытый чат всегда был виден в списке.
 */
export function visibleProjectGroups(
  groups: ProjectGroup[],
  opts: { showAll: boolean; activeProjectId?: string | null; limit?: number }
): { visible: ProjectGroup[]; hidden: number } {
  const limit = opts.limit ?? PROJECTS_COLLAPSED_LIMIT
  if (opts.showAll || groups.length <= limit) return { visible: groups, hidden: 0 }
  const visible = groups.slice(0, limit)
  const active = opts.activeProjectId ? groups.find((g) => g.project.id === opts.activeProjectId) : undefined
  if (active && !visible.includes(active)) visible.push(active)
  return { visible, hidden: groups.length - visible.length }
}
